import { h } from 'preact'
import { useState } from 'preact/hooks'
import { tagParser, proxymedia } from '../../js/modules/utilities.js'

export const TuileDevice = ({ tag, DAS, image, brand, model, capacity, color, from_price, price_without_promo, price, CTA: { URL, analytics }, sr_only, price_small = false }) => {
   const [tooltip, setTooltip] = useState(false)
   const toggleTooltip = (e) => {
      e.preventDefault()
      setTooltip((prevTooltip) => !prevTooltip)
   }

   return (
      <div class="tuile-device">
         <a
            href={URL}
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-pdb-ta={analytics.pdbTa}
            data-adv-canal={analytics.advCanal}
            data-adv-cappingdata={analytics.advCappingdata}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            {tag && (
               <div class="tag">
                  <div class="ob1-tag ob1-tag-primary">{tag}</div>
               </div>
            )}

            <div class="content-top">
               <img class="image" src={`${proxymedia(image, 'saveas=webp')}`} alt="" loading="lazy" />
            </div>

            <div class="content-bottom">
               <h3 class="model-parent h4">
                  <span class="brand">{brand}</span>
                  <span class="model">{model}</span>
                  <span class="description">
                     <span class="capacity">{capacity}</span>
                     <ColorDisc hex={color} />
                  </span>
               </h3>

               {price && (
                  <div class="price ob1-price text-right" data-ob1-component="Price">
                     <span class="sr-only">{sr_only}</span>
                     <p aria-hidden="true">
                        {from_price === true && <span class="ob1-price-from">à partir de</span>}
                        {from_price === false && price_without_promo !== '' ? <s class="ob1-price-without-promo">{price_without_promo}</s> : null}
                        <span class={`ob1-price-amount ${price_small ? 'price-small' : ''}`}>{price}</span>
                     </p>
                  </div>
               )}
            </div>
         </a>

         {DAS && (
            <div class={`das text-dark ob1-tooltip ${tooltip && 'active'}`}>
               <button class="ob1-tooltip-trigger picto-das btn" aria-label={`DAS ${brand} ${model}`} onClick={toggleTooltip}>
                  <span class="icon icone-info text-dark" aria-hidden="true">
                     <svg viewBox="0 0 32 32">
                        <path d="M16 0c8.836 0 16 7.164 16 16s-7.164 16-16 16-16-7.164-16-16 7.164-16 16-16zM17.687 11.693h-3.358v11.346c0.138 0.719 0.83 1.268 1.669 1.268s1.552-0.548 1.689-1.268v-11.346zM16 5.991c-0.502 0-0.957 0.205-1.286 0.535l-0 0c-0.329 0.331-0.532 0.786-0.532 1.29 0 0 0 0.001 0 0.001v-0c-0 0.009-0 0.020-0 0.031 0 0.667 0.358 1.251 0.892 1.569l0.008 0.005c0.263 0.157 0.579 0.25 0.918 0.25s0.655-0.093 0.926-0.254l-0.008 0.005c0.543-0.323 0.9-0.907 0.9-1.574 0-0.011-0-0.022-0-0.033l0 0.002c0-1.008-0.814-1.825-1.818-1.826z"></path>
                     </svg>
                  </span>
                  <strong class="text-dark" aria-hidden="true">DAS</strong>
               </button>

               <div class="ob1-tooltip-content ob1-tooltip-bottom" id="tooltip-content-bottom">
                  <span dangerouslySetInnerHTML={{ __html: tagParser(DAS) }}></span>
               </div>
               <div class="ob1-tooltip-shadow"></div>
            </div>
         )}
      </div>
   )
}

export const ColorDisc = ({ hex }) => {
   // Remove the '#' character if present
   const rgb = hex.replace(/^#/, '')

   // Check if the HEX code is valid
   if (rgb.length !== 6) {
      return null
   }

   // Convert HEX values to RGB
   const r = parseInt(rgb.substring(0, 2), 16)
   const g = parseInt(rgb.substring(2, 4), 16)
   const b = parseInt(rgb.substring(4, 6), 16)

   // Calculate the border color based on brightness
   const luminosity = (r * 299 + g * 587 + b * 114) / 1000
   const borderColor = luminosity > 128 ? '#ccc' : '#fff'

   return <span class="device-color" style={{ background: hex, borderColor }}></span>
}
